module.exports = __webpack_public_path__ + "static/media/home_ZT_card.bf505c8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/home_ZT_card.png
// module id = 700
// module chunks = 0 1